import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const LoyaltyInfoLoadable = Loadable({
    loader: (): any => import('./LoyaltyInfo').then((res) => res.LoyaltyInfo),
    loading: <Loader/>,
});
